import { TitreDescriptionVideo } from '@components/titre-description-video/models';
import { videoMock } from '@mock/schema/components/shared';
import { Block } from '@shared/models';

export const titreDescriptionVideoMock = (isYoutubeVideo = false): Block<TitreDescriptionVideo> => ({
  type: 'titre-description-video',
  data: {
    title: {
      text: 'On rentre en contact ?',
      as: 'h1',
    },
    description: `<p>L'aventure SoCoo'c, c'est d'abord une rencontre. Notre équipe de développeurs réseau seront vos interlocuteurs privilégiés jusqu'à l'ouverture de votre magasin.</p><p>Contactez-les pour discuter de <a href="/mock-espace-franchise/carte-des-opportunites">votre projet</a> !</p>`,
    video: isYoutubeVideo
      ? {
          link: 'https://www.youtube.com/watch?v=PVTSyoZteqo',
          legend: `Les 3 grandes étapes pour préparer la pose de votre cuisine équipée`,
        }
      : videoMock(),
  },
});
